const reticencias = (
  texto: string | null | undefined,
  tamanho: number
): string | null | undefined => {
  return texto && texto.length >= tamanho + 3
    ? texto.substring(0, tamanho).replace(/\s+/g, ' ').concat('...')
    : texto;
};

export { reticencias };
